/**
 * Hotel: Overall score + 7 categories
 * Restaurant: Overall score + 6 categories
 * Order matters — determines dropdown display order
 */
const HOTEL_CATEGORY_VALUES = [
  'total', 'Location', 'Cleanness', 'Room', 'Amenities', 'F & B', 'Service', 'Value'
];

const RESTAURANT_CATEGORY_VALUES = [
  'total', 'Food Quality', 'Beverage Quality', 'Service Quality', 'Ambience', 'Cleanliness', 'Value For Money'
];

export function filterCategoryByVenue(categories, isHotel) {
  const order = isHotel ? HOTEL_CATEGORY_VALUES : RESTAURANT_CATEGORY_VALUES;
  return order
    .map(val => categories.find(item => item.value === val))
    .filter(Boolean);
}
